import React from 'react';
import Header from '../AssetHealthApp/Header';
import ReportsBody from './ReportBody';

const Report = ({ appName }) => (
  <>
    <Header BrandText={'Analytics'} />

    <ReportsBody appName={appName} />
  </>
);

export default Report;
